import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { addCustomerPostApi, getSupplierCustomersApi } from "../../Api/SupplierServices";
import ManageCustomerContainer from "../../Components/ManageCustomerContainer/ManageCustomerContainer";
import MenuTitle from "../../Components/MenuTitlle/MenuTitle";
import Modal from "../../Components/Modal/Modal";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import Style from "./ManageCustomer.module.css";
import "./ManageCustomer.css";

const ManageCustomer = () => {
  const [customer, setCustomer] = useState();
  const [openModal, setopenModal] = useState(false);
  useEffect(() => {
    getSupplierCustomers();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onsubmit = (data) => { 
    let info = {
        phone:data.phone,
        first_name:data.fname,
        last_name:data.lname
    }
    addCustomerPostApi(info,res=>{
      if(res.status===1){
        succToast(res.message)
      }else{
        errorToast(res.message)
      }
      getSupplierCustomers()
    })
  };
  const getSupplierCustomers = async () => {
    const result = await getSupplierCustomersApi();
    setCustomer(result.customer);
  };
  const openModalHandle = () => {
    setopenModal(!openModal);
  };
  const data =
    customer &&
    customer.map((item, index) => {
      return {
        key: index,
        FName: item.first_name+' '+ item.last_name,
        phone: item.phone,
        signup: item.user_exists,
      };
    });
  return (
    <div className={Style.pageHolder}>
      <Modal show={openModal} modalClose={openModalHandle} translate={40}>
        <form onSubmit={handleSubmit(onsubmit)} className={Style.inputHolder}>
          <input {...register("fname",{required:true})} placeholder={"نام"} className={errors.fname?Style.errorInput:Style.inputStyle} />
          <input {...register("lname",{required:true})} placeholder={"نام خانوادگی"} className={errors.lname?Style.errorInput:Style.inputStyle} />
          <input {...register("phone",{required:true})} placeholder={"شماره تماس"} className={errors.phone?Style.errorInput:Style.inputStyle} />
          <div>
            <button type="submit" className={Style.addBtn}>افزودن</button>
          </div>
        </form>
      </Modal>
      <MenuTitle title={"مدیریت مشتریان"} />
      <section className={Style.tablePart}>
        <div className={Style.addBtnHolder}>
          <button onClick={openModalHandle} className={Style.addBtn}>
            افزودن مشتری
          </button>
        </div>
        <ManageCustomerContainer data={data} />
      </section>
    </div>
  );
};

export default ManageCustomer;
